var _circle, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWlgold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 280.6,
    cy: 258.3,
    r: 186.2,
    fill: "#fabc0d",
    stroke: "#000",
    strokeWidth: 11,
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.3,
    cy: 258.3,
    rx: 96.5,
    ry: 185.9,
    fill: "#fabc0d",
    stroke: "#000",
    strokeWidth: 11,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280 75v367",
    fill: "none",
    stroke: "#000",
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M419 136a186 102 0 0 1-138 34 186 102 0 0 1-139-33m277 244a186 102 0 0 0-138-34 186 102 0 0 0-139 34",
    fill: "none",
    stroke: "#000",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8f8f8",
    d: "M261 233a66 66 0 0 0 41-12l17-21c11-13 16-18 26-23 14-7 23-8 36-6 17 3 35 15 43 38l47 18c11 1 17 7 17 19 0 10-6 20-15 25-13 5-27 5-38 4-10-1-19-4-28-3-11 0-27 4-38 10-23 10-48 28-62 39-15 11-29 16-44 22-24 7-49 5-73 6-28 0-56-1-77 5-30 7-57 17-81 36-15 3-21-4-18-18 12-21 27-40 46-56A248 248 0 0 1 95 58c6-6 13-6 20 1l27 43c21-26 46-44 77-55 9-3 19-5 29-5 6 0 11 4 13 9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7bdb2",
    d: "m164 97 84 131v18l-30-3-76-120c6-9 15-21 22-26z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m412 218 60 22s5 6 2 12c-5 8-11 9-24 10s-37-4-37-4-31 1-53 13c-26 13-47 32-74 47-22 12-33 16-58 18s-68-2-102 2c-33 4-74 19-101 40 13-23 27-38 50-59 0 0-21-49-23-99-2-34 4-62 18-95 12-32 34-59 34-59l114 177s33 4 55 2c22-3 29-10 42-21 13-12 15-21 28-30 17-12 36-13 49-6 9 5 19 15 20 31 2 22 1 39 1 39",
    fill: "#ece9e7",
    stroke: "#000",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cdcfd",
    d: "m418 225 51 18c3 5-3 12-7 13-12 3-25 3-44-2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ede9e7",
    d: "M248 53v176L163 98c28-26 57-40 85-45Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M142 122c44-57 80-63 106-68l1 190",
    fill: "none",
    stroke: "#000",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWlgold);
export default __webpack_public_path__ + "static/media/WLGOLD.ad168e7c15cd27d1673c571d0d7c3960.svg";
export { ForwardRef as ReactComponent };